import React from 'react'

export const ContactUs = () => {
  return (
      <>
        <div className='container-fluid text-center'>
            <div>
            <h3 className='fw-bolder mt-5 text-light'>Contact Us</h3>3
            <p className=' text-white lh-lg mt-3 lead'>
                12A/26, F1, Mookambikai Enclave<br/>
                Devikarumariamman Nagar 2nd street<br/>
                Sunnambu Kolathur<br/>
                Kovilambakkam<br/>
                Chennai-600117<br/>
                +91 8072851166
            </p>
            </div>
        </div>
    </>
  )
}
